<template lang='pug'>
div
  HeadBlock(:info='info.head')
  PartnerGridBlock(:isEdu="false" :partner='info.partner' type="partners")
  PartnerGridBlock(:isEdu="true" :partner='info.eduPartner' type="eduPartners")
  PartnerGridBlock(:isEdu="false" :partner='info.govPartner' type="govPartners")
  div(:class='"static-bottom"')
</template>
<script>
import HeadBlock from '@/components/static/head_block.vue'
import PartnerGridBlock from '@/components/static/partner_grid_block.vue'
import PopupContentContactForm from '@/components/popup/popup_content_contact_form.vue'
import PopupContentText from '@/components/popup/popup_content_text.vue'
import { login } from '@/plugins/login.js'

export default {
  data() {
    return {
      popupContactForm: false,
      popupContentText: false
    }
  },
  components: {
    HeadBlock,
    PartnerGridBlock,
    PopupContentContactForm,
    PopupContentText
  },
  props: {
    partner: Object,
    government: Object,
    education: Object,
    info: Object
  },
  methods: {
    togglePopupContactForm() {
      if (!localStorage.getItem(this.$store.state.storageKeys.token))
        login(this.$store.state)
      else this.popupContactForm = !this.popupContactForm
    },
    isSuccess() {
      this.text=['表單已送出，我們會盡快與您聯繫，感謝您的來信。']
      this.popupContentText = true
    },
    isError() {
      this.text=['發生錯誤，請稍後再試']
      this.popupContentText = true
    }
  }
}
</script>
